import type { TabRegistryEntry } from "@/types/tabs";
import { LayoutDashboard, Clock, CreditCard, FolderOpen, Receipt, FileText, MessageSquare, User } from "lucide-react";

import WorkerDashboard from "@/pages/portal/WorkerDashboard";
import WorkerHours from "@/pages/portal/WorkerHours";
import WorkerPayments from "@/pages/portal/WorkerPayments";
import WorkerProjects from "@/pages/portal/WorkerProjects";
import WorkerReimbursements from "@/pages/portal/WorkerReimbursements";
import WorkerDocuments from "@/pages/portal/WorkerDocuments";
import WorkerMessages from "@/pages/portal/WorkerMessages";
import WorkerProfile from "@/pages/portal/WorkerProfile";
import Comms from "@/pages/controller/Comms";

export const workerTabRegistry: TabRegistryEntry[] = [
  { routePattern: "/portal/worker", component: WorkerDashboard, label: "Home", icon: LayoutDashboard, closable: false, singleton: true },
  { routePattern: "/portal/worker/hours", component: WorkerHours, label: "Hours", icon: Clock, closable: true, singleton: true },
  { routePattern: "/portal/worker/payments", component: WorkerPayments, label: "Payments", icon: CreditCard, closable: true, singleton: true },
  { routePattern: "/portal/worker/projects", component: WorkerProjects, label: "Projects", icon: FolderOpen, closable: true, singleton: true },
  { routePattern: "/portal/worker/reimbursements", component: WorkerReimbursements, label: "Reimbursements", icon: Receipt, closable: true, singleton: true },
  { routePattern: "/portal/worker/documents", component: WorkerDocuments, label: "Documents", icon: FileText, closable: true, singleton: true },
  { routePattern: "/portal/worker/messages", component: WorkerMessages, label: "Messages", icon: MessageSquare, closable: true, singleton: true },
  { routePattern: "/portal/worker/profile", component: WorkerProfile, label: "Profile", icon: User, closable: true, singleton: true },
  { routePattern: "/portal/worker/comms", component: Comms, label: "Comms", icon: MessageSquare, closable: true, singleton: true },
];
